export default "__VITE_ASSET__Btt9cEo1__"